import { render, staticRenderFns } from "./FloorListTable.vue?vue&type=template&id=db874e5c&"
import script from "./FloorListTable.vue?vue&type=script&lang=js&"
export * from "./FloorListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports